import React from 'react';
import {
  Create,
  fetchEnd,
  crudGetOne,
  fetchStart,
  showNotification,
  resolveRedirectTo
} from 'react-admin';
import { connect } from 'react-redux';
import { FormSpy } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';

import NavigationPrompt from '../../core/components/NavigationPrompt';
import CreateToolbar from '../../core/components/CreateToolbar';
import FormTitleBar from '../../core/components/FormTitleBar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import SplitMethodSummary from './SplitMethodSummary';
import SplitMethodApi from '../../core/apis/SplitMethodApi';
import SimpleFormWithSave from '../../core/components/form/SimpleFormWithSave';
import { getIcError } from '../../core/providers/utils';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const SplitMethodTitle = ({ record }) => {
  return (
    <FormTitleBar
      name=""
      status=""
      creation={true}
      showAvatar
      avatarContent="SM"
      type="Split Method"
      recordLabel="Split Method"
    />
  );
};

class SplitMethodCreate extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  handleFormIsDirty(dirty) {
    // Block navigation when the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  }

  allowNavigationOnSave = () => {
    this.setState({ whenBlockNavigation: false });
  };

  handleSubmit = async ({ name, externalId, type, file }) => {
    const {
      fetchEnd,
      fetchStart,
      showNotification,
      history,
      basePath
    } = this.props;
    const formData = new FormData();

    fetchStart();

    if (name) {
      formData.append('name', name);
    }
    if (externalId) {
      formData.append('externalId', externalId);
    }
    if (type) {
      formData.append('type', type);
    }
    if (file) {
      formData.append('file', file.rawFile, file.title);
    }
    try {
      const splitMethodResponse = await SplitMethodApi.create(formData);

      history.push(
        resolveRedirectTo(
          'edit',
          basePath,
          splitMethodResponse.id,
          splitMethodResponse
        )
      );
      showNotification('ra.notification.created');
    } catch (err) {
      showNotification('ra.notification.server', 'error', {
        messageArgs: { message: getIcError(err.response) }
      });
    } finally {
      fetchEnd();
    }
  };

  render() {
    const { whenBlockNavigation } = this.state;
    const {
      classes,
      fetchStart,
      fetchEnd,
      showNotification,
      crudGetOne,
      ...rest
    } = this.props;

    return (
      <React.Fragment>
        <NavigationPrompt when={whenBlockNavigation} creation>
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Create
          {...rest}
          title={<SplitMethodTitle />}
          classes={{ noActions: classes.noActions }}
        >
          <SimpleFormWithSave
            toolbar={
              <CreateToolbar
                allowNavigationOnSave={this.allowNavigationOnSave}
              />
            }
            variant="standard"
            margin="normal"
            redirect="edit"
            onSave={this.handleSubmit}
          >
            <SplitMethodSummary />
            <FormSpy
              subscription={{ dirty: true }}
              onChange={props => {
                this.handleFormIsDirty(props.dirty);
              }}
            />
          </SimpleFormWithSave>
        </Create>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  showNotification,
  fetchStart,
  fetchEnd,
  crudGetOne
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(SplitMethodCreate));
